var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row hero",class:_vm.layout,style:({
    'align-items':
      _vm.$route.name == 'deixe-seu-perfil' || _vm.$route.name == 'meu-perfil'
        ? 'flex-start'
        : 'center',
  })},[_c('div',{staticClass:"text col-12 col-sm-10 col-md-8 col-xl-6 d-flex flex-column justify-content-center"},[_c('h1',{staticClass:"text-white m-0",style:({
        'font-weight':
          _vm.$route.name == 'deixe-seu-perfil' || _vm.$route.name == 'meu-perfil'
            ? '300'
            : 'bold',
      })},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_c('div',{staticClass:"media-content"},[(_vm.image)?_c('img',{staticClass:"rounded shadow-lg",style:({
        'object-position':
          _vm.$route.name == 'deixe-seu-perfil' || _vm.$route.name == 'meu-perfil'
            ? '0 -100px'
            : '',
      }),attrs:{"src":require(`@/assets/images/${_vm.image}`)}}):_vm._e(),(_vm.video)?_c('video',{staticClass:"bg-dark",attrs:{"autoplay":"","loop":"","playsinline":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require(`@/assets/videos/${_vm.video}`)}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }